import { Redirect, Switch } from 'react-router-dom';

import PropTypes from 'prop-types';

import AccessCardBatchFormContainer from '../components/AccessCard/AccessCardBatchFormContainer';
import AccessCardFormContainer from '../components/AccessCard/AccessCardFormContainer';
import AccessCardsBatchListContainer from '../components/AccessCard/AccessCardsBatchListContainer';
import AccessCardsListContainer from '../components/AccessCard/AccessCardsListContainer';

import Component404 from '../components/Page/_404Component';

import Route from './SentryRoute';

const Routes = ({ match }) => (
  <Switch>
    <Route
      path={`${match.path}/batches-list/:id`}
      component={AccessCardBatchFormContainer}
    />
    <Route
      path={`${match.path}/batches-list`}
      exact
      component={AccessCardsBatchListContainer}
    />
    <Route
      path={`${match.path}/list/:id`}
      component={AccessCardFormContainer}
    />
    <Route
      path={`${match.path}/list`}
      exact
      component={AccessCardsListContainer}
    />
    <Route
      exact
      path={`${match.path}`}
      render={() => <Redirect to={`${match.path}/list`} />}
    />
    <Route path="*" component={Component404} />
  </Switch>
);
Routes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};
export default Routes;
